<template>
  <div class="order-search-page">
    <!-- Page Header with Icons -->
    <div class="page-header">
      <h2>Order Search</h2>
      <div class="header-icon-group">
        <router-link v-if="!isLimitedTransferUser" :to="{ name: 'CustomerOrder' }" class="header-icon-btn">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </router-link>
        <button v-if="!isLimitedTransferUser" class="header-icon-btn" :disabled="selectedRowsEmpty" @click="toggleDeleteCheck(true)">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <hr class="header-separator">

    <!-- Filter Section -->
    <div class="filter-section">
      <div class="row filter-row no-gutters">
        <!-- Wrappable Filter Controls -->
        <div class="filter-controls-wrapper">
          <div class="col-auto filter-control">
            <BasicDropdown placeholder='Manufacturer' :items="manufacturerOptions" v-model="orderSearch.manufacturer" :key="manufacturerUpdateKey"/>
          </div>
          <div class="col-auto filter-control">
            <BasicTextInput placeholder='Manufacturer Part Number' v-model="orderSearch.productNumber"/>
          </div>
          <div class="col-auto filter-control">
            <BasicTextInput placeholder='Dealer Stock Code' v-model="orderSearch.stockCode"/>
          </div>
          <div class="col-auto filter-control">
            <BasicTextInput placeholder='Contact/Cust/WS Name' v-model="orderSearch.contactName"/>
          </div>
          <div class="col-auto filter-control">
            <OrderStatusMultiSelect :options="orderStatusOptionsFiltered" v-model="orderSearch.orderStatus" :key="orderStatusUpdateKey"/>
          </div>
        </div>

        <!-- Action Buttons - ALWAYS stay on first line -->
        <div class="col-auto filter-control action-buttons">
          <div class="button-group">
            <button type="button" @click="clearSearchFilters" class="btn btn-secondary">
              <i class="fa fa-times" aria-hidden="true"></i> Clear Filters
            </button>
            <button type="button" @click="getFilteredOrders" class="btn btn-primary btn-sm" ref="searchButton">
              <i class="fa fa-search" aria-hidden="true"></i> Search
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Grid Container -->
    <div class="grid-container">
      <BasicDataGrid
      ref="orderSearchDataGrid"
      :key="dataGridUpdateKey"
      :dataSource="dataSource"
      gridRef="orderSearchGrid"
      :dataGridKey="dataGridKey"
      :columns="dynamicColumns"
      :actions="actions"
      :allowExport="false"
      :showColumnLines="true"
			:stateStoring="true"
      :searchEntireGrid="false"
      :height="gridHeight"
      v-on:clear-search="clearSearchFilters"
      @selectedRowsChanged="selectedRowsChanged"
      @deleteOrder="deleteFromGrid"
      @undeleteOrder="undeleteFromGrid"
      @commit="commitFromGrid"
      @viewOrder="viewOrder"
      @editOrder="editOrder"
      @viewVersions="viewVersions"/>
    </div>

    <Modal ref="deleteCheck">
        <div class="card modal-wrapper p-4" :class="{ 'modal-wrapper-wide': multipleOrders && selectedRows.length >= 2 }">
          <div v-if="!multipleOrders || selectedRows.length < 2">
            <p class="m-0">Are you sure you would like</p>
            <p class="mt-0 ">to delete this order?</p>
            <div class="btn-wrapper center">
              <button class="btn btn-secondary" @click="toggleDeleteCheck">Cancel</button>
              <button @click="deleteConfirmed" class="btn btn-primary">Delete</button>
            </div>
          </div>
          <div v-else-if="multipleOrders && selectedRows.length >= 2">
            <p class="m-0">You are about to delete <strong>{{ selectedRows.length }}</strong> orders.</p>
            <p class="mt-2 mb-3">To confirm, please type <strong>"delete"</strong> below:</p>
            <BasicTextInput
              v-model="deleteConfirmationText"
              placeholder="Type 'delete' to confirm"
              :focus="true"
              class="mb-3"
            />
            <div class="btn-wrapper center">
              <button class="btn btn-secondary" @click="toggleDeleteCheck">Cancel</button>
              <button
                @click="deleteConfirmed"
                class="btn btn-primary"
                :disabled="deleteConfirmationText.toLowerCase() !== 'delete'"
              >
                Delete {{ selectedRows.length }} Orders
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal ref="commitCheck">
        <div class="card modal-wrapper p-4">
          <p class="m-0">Are you sure you would like</p>
          <p class="mt-0 ">to commit order?</p>
          <div class="btn-wrapper center">
            <button class="btn btn-secondary" @click="toggleCommitCheck">Cancel</button>
            <button @click="commit" class="btn btn-primary">Commit</button>
          </div>
        </div>
      </Modal>

      <Modal ref="orderPreviewDialog">
        <OrderPreview :orderId="selectedOrderId"/>
      </Modal>
  </div>
</template>
<script>
import BasicDataGrid from '../../../components/BasicDataGrid.vue';
import DxDataGrid from 'devextreme-vue/data-grid';
import OrderPreview from '../../../components/OrderPreview.vue';
import { DxSelectBox } from 'devextreme-vue/select-box';
import OrderStatusMultiSelect from '../../../components/inputComponents/OrderStatusMultiSelect.vue';
import { OrderService, DealerService, TableConfigService } from '../../../services';
import { mapState } from 'vuex'
import { userRoleEnum , getKeyByValue } from "../../../modules/helpers.js";

import 'devextreme/dist/css/dx.light.css';

export default {
  name: 'OrderSearch',
  components: {
    BasicDataGrid,
    DxSelectBox,
    DxDataGrid,
    OrderPreview,
    OrderStatusMultiSelect
  },
  data() {
    // const manufacturers = DealerService.manufacturersByDealer();
    // const serviceUrl = DealerService.manufacturersByDealer();
    //     const store = createStore({
    //         key: "ID",
    //         loadUrl: serviceUrl
    //     });
    // console.log(store);
    return {
      // data,
      // editBoxValue: simpleProducts[0],
      // product: simpleProducts[0].ID,
      searchModeOption: 'contains',
      searchExprOption: 'DisplayName',
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
      searchExprItems: [
        {
          name: "'DisplayName'",
          value: 'DisplayName',
        },
        // {
        //   name: "['Name', 'Category']",
        //   value: ['Name', 'Category'],
        // },
      ],
      dataGridKey: 'Id',
      dataGridUpdateKey: 1,
      dataSource: [],
      windowHeight: window.innerHeight,
      manufacturersByDealer: [],
      actions: [
        {
          key: 'delete',
          hint: 'Delete',
          icon: 'trash',
          emit: 'deleteOrder',
          visible: (e) => !e.row.data.IsDeleted
        },
        {
          key: 'undelete',
          hint: 'Undelete',
          icon: 'undo',
          emit: 'undeleteOrder',
          visible: (e) => e.row.data.IsDeleted && this.canViewDeletedOrders
        },
        {
          key: 'edit',
          hint: 'Edit',
          icon: 'edit',
          emit: 'editOrder',
          visible: (e) => !e.row.data.IsDeleted
        },
        {
          key: 'versions',
          hint: 'View Version History',
          icon: 'clock',
          emit: 'viewVersions',
          visible: () => this.isSalesAdmin && process.env.VUE_APP_ENABLE_ORDER_VERSIONING === 'true'
        },
        {
          key: 'open',
          hint: 'Preview Order',
          icon: 'info',
          emit: 'viewOrder'
        }
      ],
      multipleOrders: false,
      orderStatusUpdateKey: 0,
      manufacturerUpdateKey: 0,
      manufacturerOptions: [],
      orderSearch: {
        productNumber: null,
        productDescription: null,
        stockCode: null,
        orderStatus: JSON.parse(sessionStorage.getItem('orderSearchStatus')) ?? [1],
        manufacturer: null,
        owner: null,
        contactName: null
      },
      orderStatusOptions: [
        { text: 'Working / Open',      value: 1,         requiresAccess: null },
        { text: 'On Hold / Cancelled', value: 2,         requiresAccess: null },
        { text: 'Submitted',           value: 3,         requiresAccess: null },
        { text: 'Added As Add. Rep',   value: 'addRep',  requiresAccess: null },
        // TODO: Archived - { text: 'Archived', value: 'archived', requiresAccess: null } (deferred - requires IsArchived DB field)
        { text: 'Deleted',             value: 'deleted', requiresAccess: null },
        { text: 'Other Reps Orders',   value: 'allReps', requiresAccess: 'allReps' },
      ],
      selectedRows: [],
      defaultcolumns: [
        {text: 'Order #', width: '150px', value: 'OrderNumber', dataType: "string"},
        {text: 'Order Date', width: '100px', value:'CreatedOn', dataType: "date", sortOrder: 'desc'},
        {text: 'Order Owner', width: '175px', value:'SalesRepFullName', dataType: "string"},
        {text: 'Worksheet Name', width: 'auto', value:'WorksheetName', dataType: "string"},
        {text: 'Customer #', width: '75px', value:'JdeNumber', dataType: "string"},
        {text: 'Bill Name', width: 'auto', value:'BillingInfo.Name', dataType: "string"},
        {text: 'Bill State', width: '75px', value:'BillingInfo.StateProvince', dataType: "string"},
        {text: 'Bill City', width: '75px', value:'BillingInfo.City', dataType: "string"},
        {text: 'Ship Name', width: '75px', value:'ShippingInfo.Name', dataType: "string"},
        {text: 'Ship State', width: '75px', value:'ShippingInfo.StateProvince', dataType: "string"},
        {text: 'Ship City', width: '75px', value:'ShippingInfo.City', dataType: "string"},
        {text: 'Install Date', width: '75px', value:'InstalledOn', dataType: "date"},
        {text: 'Revise Date', width: '75px', value:'RevisedOn', dataType: "date"},
        {text: 'Expire Date', width: '75px', value:'ExpiresOn', dataType: "date"},
        {text: 'Status', width: '75px', value:'IsDeleted', dataType: "boolean", cellTemplate: 'statusTemplate', visible: true}
      ],
      columns: [],
      submittedId: 3,
      orderId: 0,
      popupAttributes: {
          id: 'elementId',
          class: 'dxSelect'
      },
      selectedOrderId: 0,
      isLimitedTransferUser: false,
      deleteConfirmationText: ''
    };
  },
  methods: {
    getDisplayExpr(item) {
      //console.log(item);
      return item && item.DisplayName;
    },
    clearSearchFilters() {
      // Clear the form filters - reset to default: owned Working/Open orders only
      this.orderSearch = {
        productNumber: null,
        productDescription: null,
        stockCode: null,
        orderStatus: [1],
        manufacturer: null,
        owner: null,
        contactName: null
      }

      // Clear the grid-level filters (column filters, search panel, etc.)
      if (this.$refs.orderSearchDataGrid) {
        this.$refs.orderSearchDataGrid.clearSearchPanel(false); // Pass false to prevent emit
      }

      this.dataGridUpdateKey = this.dataGridUpdateKey + 1;
      this.orderStatusUpdateKey++
      this.getFilteredOrders()
    },
    goToMostRecentOrder(){
      OrderService.mostRecent()
        .then(res => {
          this.$router.push({ name: 'CustomerOrderEdit', params: { id: res.Id, cid: res.CustomerId } } );
        })
        .catch(err => {
          console.log(err)
        })
    },
    editOrder(e){
      let orderId = e.row.data.Id;
      let customerId = e.row.data.CustomerId;
      this.$router.push({ name: 'CustomerOrderEdit', params: { id: orderId, cid: customerId } } );
    },
    viewOrder(e) {
      this.selectedOrderId = e.row.data.Id;
      this.$refs.orderPreviewDialog.openModal();
    },
    viewVersions(e) {
      const orderId = e.row.data.Id;
      this.$router.push({ name: 'OrderVersions', params: { id: orderId } });
    },
    openOrder(e) {
      const orderId = e.row.data.Id;
      const customerId = e.row.data.CustomerId;
      const routeData = this.$router.resolve({ name: 'CustomerOrderEdit', params: { id: orderId, cid: customerId } });
      window.open(routeData.href, '_blank');
    },
    deleteFromGrid(e){
      this.toggleDeleteCheck(false)
      // this.order = e.row.data
      this.orderId = e.row.data.Id;
    },
    undeleteFromGrid(e){
      this.undeleteOrder(e.row.data.Id);
    },
    commitFromGrid(e){
      this.toggleCommitCheck(false)
      this.order = e.row.data
      this.orderId = [e.row.data.Id];
      // this.commitOrders(orderId)

    },
    commit(){
      this.multipleOrders ?
      this.commitMultipleRows() :
      this.commitOrders(this.orderId)
    },
    commitOrders(ids, message){
      let commitMessage = message || 'Order Committed'
      if(this.order.OrderStatusId === this.submittedId) {
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'This order has already been submitted' , type: 'error' });
        this.order = {};
        this.toggleCommitCheck()
        return;
      }
      else if(this.order.InstalledOn === null){
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Please add an Installation Date to the order before committing' , type: 'error' });
        this.order = {};
        this.toggleCommitCheck()
        return;
      }
      OrderService.commit(ids)
        .then(() => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: commitMessage , type: 'success' });
          this.selectedRows = []
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
        this.toggleCommitCheck()
    },
    toggleCommitCheck(multiple){
      this.multipleOrders = multiple;
      this.$refs.commitCheck.toggle();
    },
    toggleDeleteCheck(multiple){
      this.multipleOrders = multiple;
      // Reset confirmation text when opening the modal
      this.deleteConfirmationText = '';
      // Debug logging
      console.log('toggleDeleteCheck - multipleOrders:', this.multipleOrders, 'selectedRows.length:', this.selectedRows.length);
      this.$refs.deleteCheck.toggle();
    },
    commitMultipleRows(){
      let committedRows = []
      let unableToCommit = []
      let ableToCommit = []
      this.selectedRows.forEach(row => {
        //console.log('row', row)
        if(row.OrderStatusId === this.submittedId || row.InstalledOn === null){
          unableToCommit.push(row.Id)
        }else {
          committedRows.push(row.Id)
          ableToCommit.push(row.Id)
        }

      })
      if(unableToCommit.length > 0){
        let message = "Unable to commit orders: "
        unableToCommit.forEach((order, index)=> {
          if(index === 0) {
            message += order;
          } else {
            message += `, ${order}`
          }
        })
        message += "."
        this.$store.dispatch('ADD_NOTIFICATION', { text: message , type: 'error' });
      }
      let commitMessage ="Committed Orders: "
      if(ableToCommit.length > 0){
        ableToCommit.forEach((order, index)=> {
          if(index === 0) {
            commitMessage += order;
          } else {
            commitMessage += `, ${order}`
          }
        })
        commitMessage += "."
      }
      if(committedRows.length <= 0) return;
      this.commitOrders(committedRows, commitMessage)
    },
    deleteConfirmed(){
      this.multipleOrders ?
      this.deleteMultipleRows() :
      this.deleteOrder(this.orderId)
    },
    deleteMultipleRows(){
      let deletedRows = []
      this.selectedRows.forEach(row => {
        deletedRows.push(row.Id)
      })
      deletedRows.sort(function(a,b){ return b - a; })
      OrderService.deleteMultiple(deletedRows)
        .then(() => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: "Selected Orders have been deleted" , type: 'success' });
          // for (var i = deletedRows.length -1; i >= 0; i--){
          //   let index = this.orders.map(order => order.Id).indexOf(deletedRows[i])

          //   this.orders.splice(index,1);
          // }
          this.dataGridUpdateKey = this.dataGridUpdateKey + 1;
          this.selectedRows = []
          this.$store.dispatch('UPDATE_FAVORITES');
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
        .finally(() => {
          this.toggleDeleteCheck();
        })
    },

    deleteOrder(){
      OrderService.delete({id: this.orderId})
        .then((res) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: "Order has been deleted" , type: 'success' });
          this.dataGridUpdateKey = this.dataGridUpdateKey + 1;
          this.$store.dispatch('UPDATE_FAVORITES');
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
        .finally(()=> {
          this.toggleDeleteCheck();
        })

    },
    undeleteOrder(orderId){
      OrderService.undelete({id: orderId})
        .then((res) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: "Order has been restored" , type: 'success' });
          this.dataGridUpdateKey = this.dataGridUpdateKey + 1;
          this.$store.dispatch('UPDATE_FAVORITES');
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
    },
    selectedRowsChanged(rows){
      this.selectedRows = rows;
    },
    getFilteredOrders(){
        const selected = this.orderSearch.orderStatus || [1];

        const statusIds = selected.filter(v => typeof v === 'number');
        const includeAddRep = selected.includes('addRep');
        const includeAllReps = selected.includes('allReps');
        const includeDeleted = selected.includes('deleted');
        const onlyDeleted = includeDeleted && statusIds.length === 0 && !includeAddRep && !includeAllReps;
        const onlyAddRep = includeAddRep && statusIds.length === 0 && !includeAllReps;
        const onlyAllReps = includeAllReps && statusIds.length === 0 && !includeAddRep;

        let data = {
          PartNumber: this.orderSearch.productNumber,
          PartDescription: this.orderSearch.productDescription,
          StockCode: this.orderSearch.stockCode,
          StatusIds: statusIds,
          Manufacturer: this.orderSearch.manufacturer,
          OrderOwner: this.orderSearch.owner,
          ContactName: this.orderSearch.contactName,
          IncludeDeleted: includeDeleted,
          OnlyDeleted: onlyDeleted,
          IncludeAdditionalRepOrders: includeAddRep,
          OnlyAdditionalRepOrders: onlyAddRep,
          IncludeAllRepsOrders: includeAllReps,
          OnlyAllRepsOrders: onlyAllReps,
        };
        this.dataSource = OrderService.filtered(this.dataGridKey, data)
    },
    getOrders(){
        //console.log(this.dataGridKey);
        this.dataSource = OrderService.getDataSource(this.dataGridKey)
        //console.log('DataSource: ', this.dataSource);
    },
    onStateResetClick() {
      this.dataGridKey = null;
      // clearFilter("search");
    },
    async getManufacturers(){
      // console.log(this.dataGridKey);
      this.manufacturersByDealer = await DealerService.manufacturersByDealer() ;

      // Remove duplicates and populate manufacturer options for dropdown
      const uniqueManufacturers = this.manufacturersByDealer.reduce((acc, current) => {
        const existing = acc.find(item => item.DisplayName === current.DisplayName);
        if (!existing) {
          acc.push(current);
        }
        return acc;
      }, []);

      this.manufacturerOptions = [
        { text: 'All Manufacturers', value: null },
        ...uniqueManufacturers.map((m, index) => ({
          text: m.DisplayName,
          value: m.DisplayName || `manufacturer_${index}` // Fallback to ensure unique values
        }))
      ];
      //console.log(this.manufacturersByDealer);
    },
    refreshGrid() {
      if (this.$refs.orderSearchDataGrid && this.$refs.orderSearchDataGrid.$refs[this.$refs.orderSearchDataGrid.gridRefKey]) {
        this.$refs.orderSearchDataGrid.$refs[this.$refs.orderSearchDataGrid.gridRefKey].instance.refresh();
      }
    },
    forceGridRefresh() {
      // Force complete grid refresh to ensure actions render correctly
      this.dataGridUpdateKey = this.dataGridUpdateKey + 1;
      this.$nextTick(() => {
        this.refreshGrid();
      });
    },
    handleResize() {
      // Update window height when window is resized
      this.windowHeight = window.innerHeight;
    }
  },
  computed: {
    ...mapState(['currentUser', 'usStates']),
    selectedRowsEmpty(){
      return this.selectedRows.length <= 0
    },
    currentUserRole(){
        return getKeyByValue(userRoleEnum, this.currentUser.UserRoleId);
    },
    canViewDeletedOrders(){
      // Authorization is now handled on the backend
      return this.currentUser.CanViewDeletedOrders || false;
    },
    canViewAllOrders(){
      return this.currentUser.CanViewAllOrders || this.isSalesAdmin || false;
    },
    isSalesAdmin(){
      return this.currentUserRole === 'Sales Administrator';
    },
    orderStatusOptionsFiltered(){
      return this.orderStatusOptions.filter(option => {
        if (option.requiresAccess === 'allReps') return this.canViewAllOrders;
        return true;
      });
    },
    dynamicColumns(){
        // Return the default columns directly to avoid unnecessary re-renders
        // Status column visibility is now handled in the grid template
        return this.defaultcolumns;
    },
    shouldShowDeletedStatus(){
        const selected = this.orderSearch.orderStatus || [];
        return selected.includes('deleted') && this.canViewDeletedOrders;
    },
    gridHeight() {
      // Calculate available height for the grid more accurately
      // Account for:
      // - Top navbar (~56px)
      // - Page header (~40px)
      // - Filter section (~60px, may wrap to 2 lines)
      // - Padding and margins (~30px)
      // - Bottom padding (~20px)
      const usedHeight = 56 + 40 + 60 + 30 + 20; // ~206px
      const availableHeight = this.windowHeight - usedHeight;

      // Ensure minimum height for usability
      const minHeight = 400;
      const calculatedHeight = Math.max(availableHeight, minHeight);

      return `${calculatedHeight}px`;
    }

  },
  watch: {
    canViewDeletedOrders() {
      // Force grid refresh when permissions change to ensure actions render correctly
      this.forceGridRefresh();
    },
    'orderSearch.orderStatus'(val) {
      sessionStorage.setItem('orderSearchStatus', JSON.stringify(val));
    }
  },
  mounted() {
    this.isLimitedTransferUser = this.currentUser.IsLimitedTransferUser;

    // Set focus to the Search button
    this.$nextTick(() => {
      if (this.$refs.searchButton) {
        this.$refs.searchButton.focus();
      }
    });

    // Add window resize listener to update grid height
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // Clean up the resize listener
    window.removeEventListener('resize', this.handleResize);
  },
  async created(){
    if(this.currentUserRole === 'SmartSales Admin'){
      this.$router.push({name: 'DealerSearch'})
    } else {
      this.getManufacturers();
      this.getFilteredOrders();
    }
  }
};

</script>

<!-- Global styles for filter control heights -->
<style lang="scss">
.order-search-page .filter-control {
  input.form-control,
  select.form-control {
    height: 31px !important;
    padding: 0.25rem 0.5rem !important;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
    box-sizing: border-box !important;
  }
}
</style>

<style lang="scss" scoped>
  .order-search-page {
    // max-width: 1800px;
    // Let the grid handle its own height calculation
  }

  // Page header with icons positioned to the right
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    flex-shrink: 0; // Prevent header from shrinking

    h2 {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 500;
    }

    .header-icon-group {
      display: flex;
      align-items: center;
      gap: 15px;

      .header-icon-btn {
        background: none;
        border: none;
        color: $primary;
        font-size: 1.2rem;
        cursor: pointer;
        padding: 8px;
        border-radius: 4px;
        transition: background-color 0.2s ease;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 32px;
        min-height: 32px;

        &:hover:not(:disabled) {
          background-color: rgba($primary, 0.1);
          color: darken($primary, 10%);
        }

        &:disabled {
          color: #ccc;
          cursor: not-allowed;
        }

        i {
          margin: 0;
        }
      }
    }
  }

  // Ensure the header separator line is visible
  .header-separator {
    margin: 0.5rem 0;
    border: none;
    border-top: 1px solid #dee2e6;
    flex-shrink: 0; // Prevent separator from shrinking
  }

  .filter-section {
    margin-bottom: 0.5rem;
    flex-shrink: 0; // Prevent filter section from shrinking

    .filter-row {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: end;

      // Create a wrapper for filter controls that can wrap
      .filter-controls-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: end;
        flex: 1 1 auto;
        min-width: 0; // Allow shrinking
        // Reserve space for buttons on the right
        margin-right: 200px; // Approximate width needed for buttons

        .filter-control {
          padding-left: 0px;
          padding-right: 4px;
          margin-bottom: 2px;
          flex: 0 0 auto; // Don't grow or shrink by default

          // Make manufacturer dropdown wider for long names
          &:first-child {
            width: 300px;
            padding-left: 0px;
          }

          // Order Status - make it wrap first when space is limited
          &:nth-child(5) {
            width: 120px;
            flex: 0 1 120px; // Allow shrinking, which makes it wrap first
          }
        }
      }

      // Action buttons NEVER wrap - stay on first line always
      .filter-control.action-buttons {
        position: absolute;
        top: 0;
        right: 0;
        white-space: nowrap; // Prevent any internal wrapping

        .button-group {
          display: flex;
          gap: 8px;
          white-space: nowrap; // Prevent buttons from wrapping within the group

          .btn {
            height: 32px;
            font-size: 0.875rem;
            padding: 4px 12px;
            border-radius: 3px;

            &.btn-sm {
              height: 32px;
              font-size: 0.875rem;
            }
          }
        }
      }

      // Compact filter controls - apply to all filter controls
      .filter-control {
        .text-input,
        .form-group {
          margin-bottom: 0;

          label {
            font-size: 0.875rem;
            font-weight: 500;
            margin-bottom: 2px;
            color: #666;
          }

          .form-control,
          select {
            height: 32px;
            font-size: 0.875rem;
            padding: 4px 8px;
            border: 1px solid #ddd;
            border-radius: 3px;
            min-width: 120px;
            max-width: 160px;
          }
        }
      }
    }
  }

  // Grid container - simplified to avoid height conflicts
  .grid-container {
    // Let the grid handle its own sizing based on the height prop
    margin-top: 0.5rem;
  }

  .icon-btn{
    border: none;
    background-color: transparent;
    padding: 0px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    &.center{
      justify-content: space-around;
      align-items: center;
    }

    .btn {
      margin: 5px;
    }
  }
  .search-button {
    margin-top: 24px;
    display: flex;
    flex-direction: row-reverse;
  }
  .modal-wrapper{
    width: 300px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    &.modal-wrapper-wide {
      width: 450px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
  .dxSelect {
    z-index: 15;
    margin-top: 40px;
    position: absolute;
    max-height: 300px;
    overflow: scroll;
    width: -webkit-fill-available;
    border: solid 5px black;
  }


  .current-product {
    // padding-top: 11px;
  }

  // .dxSelect:hover  {
  //   background-color: black !important;
  // }

  .current-value {
    font-weight: bold;
  }

  .options {
    // padding: 20px;
    background-color: rgba(191, 191, 191, 0.15);
    // position: absolute;
    // right: 0;
    // top: 0;
    // bottom: 0;
    // width: 260px;
  }

  .caption {
    font-weight: 500;
    font-size: 18px;
  }

  .option {
    // margin-top: 10px;
  }
</style>
